import {ActionCreatorWithPayload, Reducer, Selector, createSelector, createSlice} from '@reduxjs/toolkit';
import {RootState} from 'app/store';

export interface ISelectionState {
    ids: string[],
    totalItems: number,
}

export type SelectionSelector<T> = Selector<RootState, T>;

export interface ISelectionSlice {
    reducer: Reducer<ISelectionState>,
    actions: {
        toggleOne: ActionCreatorWithPayload<string>,
        selectAllOnPage: ActionCreatorWithPayload<string[]>,
        clearAll: ActionCreatorWithPayload<number>,
    },
    selectedIdsSelector: Selector<RootState, string[]>,
    isSelectedAllSelector: Selector<RootState, boolean>,
}

export function createSelectionSlice(
    name: string,
    selectState: Selector<RootState, ISelectionState>,
): ISelectionSlice {
    const initialState: ISelectionState = {
        ids: [],
        totalItems: 0,
    };

    const slice = createSlice({
        name,
        initialState,
        reducers: {
            toggleOne: (state, {payload}: {payload: string}) => {
                const index = state.ids.indexOf(payload);
                if (-1 === index) {
                    state.ids.push(payload);
                }else{
                    state.ids.splice(index, 1);
                }
            },
            selectAllOnPage: (state, {payload}: {payload: string[]}) => {
                state.ids = payload;
                state.totalItems = payload.length;
            },
            clearAll: (state, {payload}: {payload: number}) => {
                state.ids = [];
                state.totalItems = payload;
            },
        },
    });

    return {
        reducer: slice.reducer,
        actions: slice.actions,
        selectedIdsSelector: createSelector(selectState, ({ids}) => ids),
        isSelectedAllSelector: createSelector(selectState, ({ids, totalItems}) => ids.length >= totalItems),
    };
}
